import FormInput from './forminput.vue'
import FormTextArea from './formtextarea.vue'
import FormCheckBox from './formcheckbox.vue'
import FormFile from './formfile.vue'
import FormPassword from './formpassword.vue'
import FormRichText from './formrichtext.vue'
import FormMultiSelect from './formmultiselect.vue'
import FormSignature from './formsignature.vue'
import FormDuration from './formduration.vue'
import FormRelationship from './formrelationship.vue'
import FormDate from './formdate.vue'
import { visibleFieldDescription } from '../../../../shared/form-field-description.js'
import { fieldNameAndHint } from '../../../../shared/form-field-label.js'

export const formControlMap = {
  formInput: FormInput,
  formTextArea: FormTextArea,
  formCheckBox: FormCheckBox,
  formFile: FormFile,
  formPassword: FormPassword,
  formRichText: FormRichText,
  formMultiSelect: FormMultiSelect,
  formSignature: FormSignature,
  formDuration: FormDuration,
  formRelationship: FormRelationship,
  formDate: FormDate
}

export const DIRECT_INPUT_TYPES = [
  'formInput',
  'formTextArea',
  'formCheckBox',
  'formFile',
  'formPassword',
  'formRichText',
  'formMultiSelect',
  'formSignature',
  'formDuration',
  'formRelationship',
  'formDate'
]

const PLACEHOLDER_TYPES = new Set([
  'formInput',
  'formTextArea',
  'formFile',
  'formPassword',
  'formRichText'
])

export function fieldValue (formValues, uniqueTitle) {

  if (!formValues || !uniqueTitle) return ''

  const value = formValues[uniqueTitle]

  return value == null ? '' : value
}

export function inputEventValue (value) {

  if (value && typeof value === 'object' && value.target && 'value' in value.target) {

    return value.target.value
  }

  return value
}

export function applyFormControlProps (instantiated, component, options = {}) {
  instantiated.description = visibleFieldDescription(component.description)

  const named = fieldNameAndHint(component.title, component.placeholder)
  const checkboxText = String(component.checkedDescription || '').trim()

  const label = component.type === 'formCheckBox' && named.label === checkboxText
    ? ''
    : named.label

  instantiated.fieldLabel = component.required && label ? `${label} *` : label
  instantiated.required = !!component.required

  if (PLACEHOLDER_TYPES.has(component.type)) {
    instantiated.placeholder = named.placeholder
  }

  if (component.type === 'formCheckBox') {
    instantiated.checkedDescription = component.checkedDescription
  }

  if (component.type === 'formDuration') {
    instantiated.durationUnit = component.durationUnit || 'hours'
  }

  if (component.type === 'formDate' || (component.type === 'formInput' && component.columnType === 'dateTime')) {
    instantiated.dateOnly = !!component.dateOnly
  }

  if (component.type === 'formFile') {
    instantiated.allowImageUrl = !!component.allowImageUrl
  }

  if (component.type === 'formMultiSelect') {
    instantiated.choices = component.choices || []
    instantiated.displayStyle = component.displayStyle || 'dropdown'
    instantiated.selectionMode = component.selectionMode || 'multiple'
    instantiated.placeholder = named.placeholder
  }

  if (options.spaceDirectInputs && DIRECT_INPUT_TYPES.includes(component.type)) {
    instantiated.needsFieldSpacing = true
  }

  if (component.components) {
    instantiated.formComponents = component.components
  }

  return instantiated
}
